import fetch from '../utils/fetch';

export const validateRedemptionCode = (accessToken, code, company) => {
  const urlPath = `/gifts/redeem?code=${code}&brand=${company}`;
  return fetch(urlPath, accessToken, { method: 'GET' });
};

export const redeem = (accessToken, code, company) =>
  fetch('/gifts/redeem', accessToken, {
    method: 'POST',
    body: JSON.stringify({ code, brand: company })
  });
